import axios from 'axios'
import appConfig from '@/appconfig'
import store from '../store'
import endpoint from '@constants/apipath'
export const actions = {
  async getUdnOrderData({ commit }, reportID) {
    return axios
      .get(
        `${appConfig.apiEndPoint}${endpoint.udn.udnCreateReport}/${reportID}`,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error.response
      })
  },
  async sendUdnOrderData({ commit }, buildVoaRequest) {
    return axios
      .post(
        `${appConfig.apiEndPoint}${endpoint.udn.udnCreate}`,
        buildVoaRequest,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error.response
      })
  },
  async getUdnSummaryData({ commit }, orderID) {
    return axios
      .get(
        `${appConfig.apiEndPoint}${endpoint.udn.getUdnSummaryDetails}/${orderID}`,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error.response
      })
  },
  async getCcrValidOrderStatus({ commit }, orderValues) {
    return axios
      .put(
        `${appConfig.apiEndPoint}${endpoint.udn.isCcrOrdervalid}/${
          orderValues.orderID
        }/${orderValues.linkedID ? orderValues.linkedID : 0}`,{},
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error.response
      })
  },
  async updateNotificationEmails({ commit }, emailsRequest) {
    return axios
      .post(
        `${appConfig.apiEndPoint}${endpoint.udn.updateUdnEmails}`,
        emailsRequest,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error.response
      })
  },
  getBureusForStandAlone({ commit }, orderId) {
    return axios
      .get(`${appConfig.apiEndPoint}${endpoint.udn.getBureaus}/${orderId}`, {
        headers: setHeaders(),
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error.response
      })
  },
  async deactivateRequest({ commit }, orderValues) {
    return axios
      .post(
        `${appConfig.apiEndPoint}${endpoint.udn.deactivateBureauRequest}/${orderValues.orderId}/${orderValues.requestNumber}`,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error.response
      })
  },
}

function setHeaders() {
  return {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${store.state.auth.currentUser.access_token}`,
  }
}
